<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h2>致股东和客户：</h2>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;">
        X年是证券增资扩股后的第一个财务年度，对公司、客户和股东来说，都是不平凡的一年。在公司1145位员工的努力下，公司经营业绩较上年取得了大幅增长：完成各项营业收入12.20亿元，实现净利润4.16亿元，分别比上年增长54.8和179.8;公司总资产95.04亿元，净资产24.62亿元，分别比上年底增长38.4和15.7;公司净资本14.09亿元，在国内券商中名列前茅。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        在公司经营业绩大幅增长的背后到底有什么故事呢?您可以认为是X年良好的市场环境造就了我们辉煌的业绩，就中国证券市场现有的发育程度和国内券商现实的竞争和生存技能来说，我们基本认同这一判断。但是，在经济全球化和中国经济正面临深刻而全面的结构调整背景下，我们认为还有一个最根本的因素促成了我们今天的成功，那就是客户对金融服务需求的增长以及我们不遗余力地为满足客户需求所作的努力。我们相信，证券的文化、有效的战略、出色的员工和公司治理创新等因素都是我们追求专业服务品牌化的力量源泉，从而实现了我们业绩的大幅增长。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        从全球范围来看，金融服务业正在重组中增长。全球范围内金融管制的放松和主要产业的重组、投资者需求的增长、金融市场的高度透明化、金融市场之间的高度关联性和从不间断的创新和技术变化等长期因素，在过去的20xx年中共同驱动着金融服务业的长期繁荣。在金融服务业的增长中，我们从全球排名前几位大投资银行的市场份额变化比较中看出，投资银行业正在走向集中，并且公司规模在确立竞争优势中的作用正变得愈来愈突出。我们认为，是客户的选择导致投资银行业走向高度集中。因为随着客户获取信息和市场进入渠道的增多，他们更容易找到在产品和服务上最优的投资银行，而这往往只有大型的投资银行才能做到。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        投资银行业这种集中增长的特性，对我们理解当前证券所面临的竞争和生存环境是很有启发意义的。与国外著名的大券商摩根斯坦利、美林、高盛等公司相比，证券的资产规模、净收入、税后利润等指标尚无法与之相提并论，但我们的总资产收益率却远远高过他们。我们所能提供的产品或服务在广度和深度上与它们也有天壤之别，特别是为客户提供良好的财务顾问能力仍是证券的弱中之弱。它需要整合财务专家、投资银行家、证券分析师或交易专家等等的专业知识和技能，不是一夜之间就能建立的。在政府对国内金融服务业的保护逐渐放松的背景下，证券面临的国外大投资银行的竞争压力是非常沉重的。

      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        回到中国资本市场现实，我们看到，中国经济近20xx年来一直维持全球最高的增长速度。中国的经济制度、金融体系也正在快速走向市场化、国际化。中国金融服务业长期以来一直处于"压制"状态，短期内市场化冲击所释放出来的增长动力和中国产业重组和升级需求，将为中国投资银行业提供前所未有的商业机会.我们认为，中国个人和机构客户不断增长的金融服务需求将成为证券追求长期发展的基础，而不断地为客户提供最优的产品和服务，则成为我们追求的长远理想。
      
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        随着中国资本市场市场化改革进程的推进，由证券经营特许权构筑起来的行业壁垒正在被打破，靠无差别的业务运作和竞争方式而坐享赢利的时代行将结束，中国投资银行业正迎来全面的竞争时代。证券要想在新一轮的竞争中脱颖而出，需要在公司的结构和战略上进行全面创新，以塑造出区别于其他证券公司的特质，而这种区别必须建立在客户关系、风险/收益管理的核心技能上。营造以客户关系、风险/收益管理技能为核心内容的竞争优势，将是证券制定和实施未来战略的关键。X年，我们将首先在投资银行业务、经纪业务和研究业务上作结构和战略上的重大调整，以适应变化的市场环境。我们还将在证券控股公司层面推行员工持股计划，以吸引并留住优秀的人才。
      
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        波动的市场环境决定了证券业永远也不可能取得其他行业的稳定性，甚至阶段性的滑坡也是可以接受的,然而这并不能改变我们追求长期增长的信念。
      
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
        最后，要感谢我们的员工长期艰苦的工作和对客户的贡献;感谢各位股东对我们事业的支持;尤其要感谢各类客户对证券的贡献。我们的目标就是拓展业务和寻找增长的机会，我们将继续努力为客户增加价值,同时创造股东价值。我们坚信，证券的明天一定会更加美好。
      
      </p>
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/yanjiang/3.vue